module.exports = __webpack_public_path__ + "static/img/lg.ajax-spinner-preloader.344f3a2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lg.ajax-spinner-preloader.gif
// module id = 915
// module chunks = 1